import React, { useState, useEffect,useRef } from "react";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    TextField,
    Button,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TableContainer,
    Typography,
    Divider,
    FormControl,
    FormLabel,
    Radio,
    RadioGroup,
    FormControlLabel
} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { Modal } from "antd";
import HttpService from "../../services/httpService";
import { CSVLink } from "react-csv";
import moment from "moment";
import InfoIcon from '@material-ui/icons/Info';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    tableContainer: {
        marginTop: '20px',
        overflow: 'auto',
        border: '1px solid #e0e0e0',
        position: 'relative',
        maxHeight: '800px',
    },
    tableWrapper: {
        overflow: 'auto',
        maxHeight: '600px'
    },
    table: {
        minWidth: '2000px',
        borderCollapse: 'collapse'
    },
    tableHeader: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500",
        border: '1px solid #e0e0e0',
        textAlign: 'center',
        position: 'sticky',
        top: 0,
        zIndex: 15,
    },
    tableCell: {
        border: '1px solid #e0e0e0',
        textAlign: 'center',
        padding: '8px'
    },
    fixedFirstColumn: {
        position: 'sticky',
        left: 0,
        backgroundColor: "#1C375D",
        zIndex: 20, // higher than other cells
        borderRight: '1px solid #e0e0e0',
        textAlign: 'center',
        padding: '8px',
        fontWeight: 'bold',
        color: '#FFF2EB',
    },
    fixedFirstColumnHeader: {
        position: 'sticky',
        left: 0,
        top: 0,
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        zIndex: 25, // above sub-headers
        borderRight: '1px solid #e0e0e0',
        textAlign: 'center',
        padding: '8px',
        fontWeight: "bold"
    },
    grandTotalRow: {
        backgroundColor: '#FFF8E1',
        fontWeight: 'bold',
        '& td': {
            fontWeight: 'bold',
        }
    },
       modalTableHeader: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500",
        border: '1px solid #e0e0e0',
        textAlign: 'center',
        padding: '8px'
    },
    modalTableCell: {
        border: '1px solid #e0e0e0',
        textAlign: 'center',
        padding: '8px'
    },
    grandTotalFixedColumn: {
        position: 'sticky',
        left: 0,
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        zIndex: 20,
        textAlign: 'center',
        padding: '8px',
        fontWeight: 'bold',
    },
    stickySubColumn: {
        position: 'sticky',
        top: 48, // height of first header row
        zIndex: 20,
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500",
        borderBottom: '1px solid #e0e0e0',
        textAlign: 'center',
        padding: '8px'
    },
    clickableCell: {
        cursor: "pointer",
        color: "#1C375D",
        textDecoration: "underline",
        '&:hover': {
            backgroundColor: '#f0f0f0'
        }
    },
    totalClickableCell: {
        cursor: "pointer",
        color: "#004d40",
        textDecoration: "underline",
        fontWeight: 'bold',
        '&:hover': {
            backgroundColor: '#f0f0f0'
        }
    },
    performanceGood: {
        backgroundColor: '#4CAF50',
        color: 'white',
        fontWeight: 'bold'
    },
    performanceAverage: {
        backgroundColor: '#FFC107',
        color: 'black',
        fontWeight: 'bold'
    },
    performanceBad: {
        backgroundColor: 'red',
        color: 'black',
        fontWeight: 'bold'
    },
    performancePoor: {
        backgroundColor: '#F44336',
        color: 'white',
        fontWeight: 'bold'
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',
        color: 'white !important',
        '&:hover': {
            backgroundColor: '#E0663D !important',
        },
    },
    clearButton: {
        backgroundColor: '#f7b7b7 !important',
        color: '#151921 !important',
    },
    csvButton: {
        backgroundColor: "#355025 !important",
        color: "#FFF2EB !important",
        marginBottom: '10px'
    },
    linkStyle: {
        color: "#000",
        textDecoration: 'underline',
        textAlign: 'center'
    },
    satisfiedDetail: {
        backgroundColor: '#e72600',
        display: 'inline-block',
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        marginRight: '5px'
    },
    DissatisfiedDetail: {
        backgroundColor: '#218b00',
        display: 'inline-block',
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        marginRight: '5px'
    },
}));

const DesignNewSummary = () => {
    const classes = useStyles();
    const [dateFilter, setDateFilter] = useState({ startDate: "", endDate: "" });
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [selectedData, setSelectedData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const [selectedStage, setSelectedStage] = useState('');
    const [selectedMonthData, setSelectedMonthData] = useState({});
    const [showLatestNotes, setShowLatestNotes] = useState(false);
    const [latestNotesMsg, setLatestNotesMsg] = useState('');
    const [latestNotesDate, setLatestNotesDate] = useState(null);
    const [showLatestDeal, setShowLatestDeal] = useState(false);
    const [latestDealMsg, setLatestDealMsg] = useState('');
    const [latestDealDate, setLatestDealDate] = useState(null);
    const [showLostInfo, setShowLostInfo] = useState(false);
    const [lostDealActivity, setLostDealActivity] = useState('NA');
    const [lostDealActivityDate, setLostDealActivityDate] = useState(null);
    const [showNpsFormModal, setShowNpsFormModal] = useState(false);
    const [npsCreatedDate, setNpsCreatedDate] = useState(null);
    const [npsFeedback, setNpsFeedback] = useState('');
    const [npsFormData, setNpsFormData] = useState([]);
    const [isManagerInvolved, setIsManagerInvolved] = useState('');
    const [managerSatisfactionForm, setManagerSatisfactionForm] = useState([]);
    const [avgScore, setAvgScore] = useState(0);
    const { userDetails } = useSelector((state) => state.user);
    const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', "Oct", "Nov", "Dec"];
    const [allPerformanceData, setAllPerformanceData] = useState([]);
    const [tableCsvData, setTableCsvData] = useState([]);
    const tableCsvButtonRef = useRef(null);
    // Headers for CSV download
    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "designStage", label: "Design Stage" },
        { key: "currentStage", label: "Current Stage" },
        { key: "totalValue", label: "Value (INR)" },
        { key: "expCtrName", label: "Exp. Ctr. Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "dateOfKickOffMeeting", label: "Kick Off Meeting Date" },
        { key: "designSignOffDate", label: "Design Sign-Off Date" },
        { key: "avgAgeingKomDays", label: "Ageing of Projects from KOM (Days)" },
        { key: "materialDeliveryDate", label: "Material Delivery Date" },
        { key: "actualCompletionDate", label: "Actual Completion Date" },
        { key: "npsDesign", label: "Nps Design" },
        { key: "npsPostDesign", label: "Nps Post Design" },
    ];


    const tableHeaders = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "designStage", label: "Design Stage" },
        { key: "currentStage", label: "Current Stage" },
        { key: "valueInr", label: "Value (INR)" },
        { key: "expCtrName", label: "Exp. Ctr. Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "dateOfKickOffMeeting", label: "Kick Off Meeting Date" },
        { key: "designSignOffDate", label: "Design Sign-Off Date" },
        { key: "avgAgeingKomDays", label: "Ageing of Projects from KOM (Days)" },
        { key: "materialDeliveryDate", label: "Material Delivery Date" },
        { key: "actualCompletionDate", label: "Actual Completion Date" },
        { key: "npsDesign", label: "Nps Design" },
        { key: "npsPostDesign", label: "Nps Post Design" },
    ];

    const tableCsvDownloadHandler = () => {
        let csvArray = [];
        for (let i = 0; i < selectedData.length; i++) {
            const data = selectedData[i];
            let valueInr = "N/A";
            if (selectedStage === "completed") {
                valueInr = data?.staticDesignWonAmount
                    ? (data.staticDesignWonAmount / 1.18) / 100000
                    : "N/A";
            } else {
                valueInr = data?.staticSalesWonBudget || "N/A";
            }

            let avgAgeingKomDays = "-";
            if (data?.dateOfKickOffMeeting && data?.designSignOffDate) {
                const diffDays = Math.floor(
                    (new Date(data.designSignOffDate) - new Date(data.dateOfKickOffMeeting)) /
                    (1000 * 60 * 60 * 24)
                );
                avgAgeingKomDays = isNaN(diffDays) ? "-" : diffDays;
            }

            let obj = {
                serialNo: i + 1,
                projectCode: data?.projectNo || data?.erpProjectNo || "N/A",
                leadNumber: data?.leadNo || data?.lead_no || "N/A",
                clientName: data?.customerName || "N/A",
                designStage: data?.designStatus || "N/A",
                currentStage: data?.currentStage || "N/A",
                valueInr: valueInr,
                expCtrName: data?.experienceCenterName || "N/A",
                salesWonDate: data?.salesWonDate
                    ? moment(data?.salesWonDate).format("DD-MM-YYYY")
                    : "-",
                dateOfKickOffMeeting: data?.dateOfKickOffMeeting
                    ? moment(data?.dateOfKickOffMeeting).format("DD-MM-YYYY")
                    : "-",
                designSignOffDate: data?.designSignOffDateActual
                    ? moment(data?.designSignOffDateActual).format("DD-MM-YYYY")
                    : "-",
                avgAgeingKomDays: avgAgeingKomDays,
                materialDeliveryDate: data?.materialDispatchedDate
                    ? moment(data?.materialDispatchedDate).format("DD-MM-YYYY")
                    : "-",
                actualCompletionDate: data?.executionCompletionDate
                    ? moment(data?.executionCompletionDate).format("DD-MM-YYYY")
                    : "-",
                npsDesign: data?.npsDesign || "-",
                npsPostDesign: data?.npsPostDesign || "-",
            };
            csvArray.push(obj);
        }
        setTableCsvData(csvArray);
        setTimeout(() => {
            tableCsvButtonRef.current.link.click();
        }, 100);
    };

    const prepareCsvData = (data) => {
        return data.map((item, index) => ({
            serialNo: index + 1,
            projectCode: item?.erpProjectNo || item?.projectNo || "N/A",
            leadNumber: item?.lead_no || item?.leadNo || "N/A",
            clientName: item?.customerName || item?.customerId?.name || "N/A",
            designStage: item?.designStatus || item?.stage || "NA",
            currentStage: item?.currentStage || "NA",
            totalValue: selectedStage === "completed"
                ? (item?.staticDesignWonAmount
                    ? (item.staticDesignWonAmount / 1.18) / 100000
                    : "N/A")
                : (item?.staticSalesWonBudget
                    ? item.staticSalesWonBudget
                    : "N/A"),
            expCtrName: item?.experienceCenterName || item?.expCtrName || item?.experienceCenter?.name || "NA",
            salesWonDate: item?.salesWonDate
                ? moment(item.salesWonDate).format("DD-MM-YYYY")
                : "-",
            dateOfKickOffMeeting: item?.dateOfKickOffMeeting
                ? moment(item.dateOfKickOffMeeting).format("DD-MM-YYYY")
                : "-",
            designSignOffDate: item?.designSignOffDateActual || item?.designSignOffDate
                ? moment(item.designSignOffDateActual || item.designSignOffDate).format("DD-MM-YYYY")
                : "NA",
            avgAgeingKomDays:
                item?.dateOfKickOffMeeting
                    ? (() => {
                        if (!item.designSignOffDate) return "-";
                        const start = new Date(item.dateOfKickOffMeeting);
                        const end = new Date(item.designSignOffDate);
                        if (isNaN(start) || isNaN(end)) return "-";
                        return Math.floor((end - start) / (1000 * 60 * 60 * 24));
                    })()
                    : "-",
            materialDeliveryDate: item?.materialDispatchedDate
                ? moment(item.materialDispatchedDate).format("DD-MM-YYYY")
                : "NA",
            actualCompletionDate: item?.executionCompletionDate
                ? moment(item.executionCompletionDate).format("DD-MM-YYYY")
                : "NA",
            npsDesign: item?.npsDesign ? item?.npsDesign  : 0,
            npsPostDesign: item?.npsPostDesign ? item?.npsPostDesign  : 0,
        }));
    };
    // Fetch data from API
    const fetchDashboardData = async () => {
        try {
            const response = await HttpService.dashboardSummary({
                startDate: dateFilter.startDate,
                endDate: dateFilter.endDate
            });
            setTableData(response.data.data || []);
            getPerformanceData(response.data.data)
        } catch (error) {
            console.error("Error fetching dashboard data:", error);
        }
    };

    useEffect(() => {
        fetchDashboardData();
    }, []);

    const handleDateFilter = () => {
        fetchDashboardData();
        getPerformanceData();
    };

    const clearDateFilter = () => {
        setDateFilter({ startDate: "", endDate: "" });
        fetchDashboardData();
        getPerformanceData();
    };

    const getPerformanceData = async (tableData) => {
        try {
            let obj = {
                userId: userDetails._id,
                startDate: dateFilter.startDate,
                endDate: dateFilter.endDate
            }
            const result = await HttpService.performanceForDesigner(obj);
            let fullData = result.data.data;

            const filteredPerformanceData = fullData?.filter(performanceItem => {
                return tableData.some(tableItem => {
                    if (tableItem._id.year !== 'Grand Total') {
                        return tableItem.year === performanceItem.year &&
                            tableItem.month === performanceItem.month;
                    }
                    return false;
                });
            }) || [];



            let grandTotalPercentage = 0;
            if (filteredPerformanceData.length > 0) {
                const sum = filteredPerformanceData.reduce((total, item) => {
                    return total + (item.performancePercentage || 0);
                }, 0);

                grandTotalPercentage = parseFloat(sum.toFixed(2));
            }

            const performanceDataWithGrandTotal = [
                ...filteredPerformanceData,
                {
                    _id: { year: 'Grand Total', month: 'Total' },
                    year: 'Grand Total',
                    month: 'Total',
                    performancePercentage: grandTotalPercentage,
                    isGrandTotal: true,
                }
            ];
            setAllPerformanceData(performanceDataWithGrandTotal);
        }
        catch (err) {
            console.error(err);
        }
    }
    const sanitizeCsvField = (value) => {
        if (value === null || value === undefined) return "NA";
        return `"${String(value)
            .replace(/[\r\n]+/g, " ")
            .replace(/\t+/g, " ")
            .replace(/,/g, " ")
            .replace(/;/g, " ")
            .replace(/\s+/g, " ")
            .replace(/"/g, '""')
            .trim()}"`;
    };



    const downloadCSV = () => {
        const csvData = prepareCsvData(selectedData);
        setCsvData(csvData);
        // Trigger CSV download
        setTimeout(() => {
            document.getElementById('csv-download-link').click();
        }, 100);
    };

    const dataBasedOnClick = async (ele, type) => {
    try {
        setSelectedStage(type);
        setSelectedMonthData(ele);
        const keyMap = {
            designKickOffInternal: "designKickOffInternalData",
            designKickOffCustomer: "designKickOffCustomerData",
            design: "designData",
            "design-Hold": "designHoldData",
            completed: "completedData",
            lost: "lostData",
            total : "total",
            npsDesign: "completedData",
            npsPostDesign: "completedData"
        };

        const selectedKey = keyMap[type];
        let leadData = [];

        if (!selectedKey) return; 

        if (type === "total" && ele.year !== "Grand Total") {
            const monthData = tableData.find(
                item => item.month === ele.month && item.year === ele.year
            );
            if (monthData) {
                leadData = [
                    ...(monthData.designKickOffInternalData || []),
                    ...(monthData.designKickOffCustomerData || []),
                    ...(monthData.designData || []),
                    ...(monthData.designHoldData || []),
                    ...(monthData.completedData || []),
                    ...(monthData.lostData || [])
                ];
            }
        } else if (ele.year === "Grand Total") {
            leadData = tableData.flatMap(item => item[selectedKey] || []);
        } else if (type === "npsDesign") {
            const monthData = tableData.find(
                item => item.month === ele.month && item.year === ele.year
            );
            leadData = (monthData?.completedData || [])?.filter(lead =>
                lead.npsDesign !== null &&
                lead.npsDesign !== undefined &&
                lead.npsDesign !== 0
            );
        } else if (type === "npsPostDesign") {
            const monthData = tableData.find(
                item => item.month === ele.month && item.year === ele.year
            );
            leadData = (monthData?.completedData || [])?.filter(lead =>
                lead.npsPostDesign !== null &&
                lead.npsPostDesign !== undefined &&
                lead.npsPostDesign !== 0
            );
        } else {
            const monthData = tableData.find(
                item => item.month === ele.month && item.year === ele.year
            );
            leadData = monthData?.[selectedKey] || [];
        }
        setShowDetailedModal(true);
        setSelectedData(leadData);
    } catch (error) {
        console.error("Error fetching detailed data:", error);
        setShowDetailedModal(false);
    }
};

    const storeDateFilter = (e) => {
        const { name, value } = e.target;
        setDateFilter({ ...dateFilter, [name]: value });
    };

    const getPerformanceClass = (percentage) => {
        if (percentage >= 80) return classes.performanceGood;
        if (percentage >= 50 && percentage < 80) return classes.performanceAverage;
        if (percentage < 50) return classes.performanceBad;
        return classes.performancePoor;
    };

    const getColor = (num) => {
        switch (num) {
            case 1:
                return '#e72600';
            case 2:
                return '#f96500';
            case 3:
                return '#ffe000';
            case 4:
                return '#30ad00';
            case 5:
                return '#218b00';
            default:
                return 'lightgray';
        }
    };

    const showNotesInfo = (data) => {
        setShowLatestNotes(true);
        setLatestNotesMsg(data.latestNotesMsg);
        setLatestNotesDate(data.latestNotesDate);
    };

    const showDealInfo = (data) => {
        setShowLatestDeal(true);
        setLatestDealMsg(data.latestDealMsg);
        setLatestDealDate(data.latestDealDate);
    };

    const showLostDetails = (data) => {
        setShowLostInfo(true);
        setLostDealActivity(data.lostDealActivity);
        setLostDealActivityDate(data.lostDate);
    };

    const showNpsDetails = (data) => {
        setShowNpsFormModal(true);
        setNpsCreatedDate(data.npsCreatedDate);
        setNpsFeedback(data.npsFeedback);
        setNpsFormData(data.npsFormData || []);
        setIsManagerInvolved(data.isManagerInvolved);
        setManagerSatisfactionForm(data.managerSatisfactionForm || []);
        if (data.npsFormData && data.npsFormData.length > 0) {
            const avg = data.npsFormData.reduce((sum, item) => sum + Number(item.actionSelected), 0) / data.npsFormData.length;
            setAvgScore(avg.toFixed(2));
        }
    };

    const avgAgeingDataBasedOnClick = (ele, type) => {
        try {
            setSelectedMonthData(ele);
            setSelectedStage('Avg Ageing of Projects from KOM')
            setShowDetailedModal(true);
            let leadData = [];

            if (type === 'avgAgeing' && ele.year !== 'Grand Total') {
                const filteredData = tableData.filter(item => item.month === ele.month && item.year === ele.year);
                const leadsArray = filteredData[0].AvgProjectKomLeads;
                // Filter leads where dateOfKickOffMeeting is not null, undefined, or empty
                leadData = leadsArray.filter(lead =>
                    lead.dateOfKickOffMeeting !== null &&
                    lead.dateOfKickOffMeeting !== undefined &&
                    lead.dateOfKickOffMeeting !== ''
                );
                // return leadData;
            } else if (ele._id.year === 'Grand Total') {
                const allLeads = tableData.flatMap(item => item.AvgProjectKomLeads || []);
                leadData = allLeads.filter(lead =>
                    lead.dateOfKickOffMeeting !== null &&
                    lead.dateOfKickOffMeeting !== undefined &&
                    lead.dateOfKickOffMeeting !== ''
                );
            }
            setSelectedData(leadData);
        } catch (err) {
            console.error('Error in avgAgeingDataBasedOnClick:', err);
        }
    };

    return (
        <div className="App">
            <Paper className={classes.paper}>
                <>
                    <Typography
                        variant="h5"
                        style={{
                            margin: "15px 5px",
                            textAlign: "center",
                            fontWeight: "bold",
                            color: 'black',
                            textDecoration: 'underline'
                        }}
                    >
                        My Summary Dashboard
                    </Typography>
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={12} sm={3}>
                            <TextField
                                id="startDate"
                                name="startDate"
                                label="Start Date"
                                type="date"
                                variant="outlined"
                                value={dateFilter.startDate}
                                onChange={storeDateFilter}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                id="endDate"
                                name="endDate"
                                label="End Date"
                                type="date"
                                variant="outlined"
                                value={dateFilter.endDate}
                                onChange={storeDateFilter}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                variant="contained"
                                onClick={handleDateFilter}
                                className={classes.submitButton}
                                fullWidth
                                disabled={loading}
                            >
                                {loading ? "Loading..." : "Submit"}
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                variant="contained"
                                onClick={clearDateFilter}
                                className={classes.clearButton}
                                fullWidth
                                disabled={loading}
                            >
                                Clear Filter
                            </Button>
                        </Grid>
                    </Grid>
                </>
            </Paper>
            <br />

            <Paper>
                <TableContainer component={Paper} className={classes.tableContainer}>
                    <Table className={classes.table} stickyHeader>
                        <TableHead>
                            {/* First Header Row */}
                            <TableRow>
                                <TableCell
                                    className={classes.fixedFirstColumnHeader}
                                    rowSpan={2}
                                >
                                    Month And Year
                                </TableCell>
                                <TableCell className={classes.tableHeader} colSpan={2}>
                                    Design KickOff Internal
                                </TableCell>
                                <TableCell className={classes.tableHeader} colSpan={2}>
                                    Design KickOff Customer
                                </TableCell>
                                <TableCell className={classes.tableHeader} colSpan={2}>
                                    Design
                                </TableCell>
                                <TableCell className={classes.tableHeader} colSpan={2}>
                                    Design-Hold
                                </TableCell>
                                <TableCell className={classes.tableHeader} colSpan={2}>
                                    Completed
                                </TableCell>
                                <TableCell className={classes.tableHeader} colSpan={2}>
                                    Lost
                                </TableCell>
                                <TableCell className={classes.tableHeader} rowSpan={2}>
                                    NPS-Design
                                </TableCell>
                                <TableCell className={classes.tableHeader} rowSpan={2}>
                                    NPS-Post-Design
                                </TableCell>
                                <TableCell className={classes.tableHeader} rowSpan={2}>
                                    Avg Ageing of Projects from KOM
                                </TableCell>
                                <TableCell className={classes.tableHeader} colSpan={2}>
                                    Total
                                </TableCell>
                                <TableCell className={classes.tableHeader} rowSpan={2}>
                                    Performance
                                </TableCell>
                                <TableCell className={classes.tableHeader} rowSpan={2}>
                                    Reward Points
                                </TableCell>
                            </TableRow>

                            {/* Second Header Row (Sub-columns: Count & Value) */}
                            <TableRow>
                                {Array(6)
                                    .fill('')
                                    .map((_, idx) => (
                                        <>
                                            <TableCell key={`count-${idx}`} className={classes.stickySubColumn}>
                                                Count
                                            </TableCell>
                                            <TableCell key={`value-${idx}`} className={classes.stickySubColumn}>
                                                Value
                                            </TableCell>
                                        </>
                                    ))}
                                <TableCell className={classes.stickySubColumn}>Count</TableCell>
                                <TableCell className={classes.stickySubColumn}>Value</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {tableData.map((ele, index) => (
                                <TableRow
                                    key={index}
                                    className={ele._id.year === 'Grand Total' ? classes.grandTotalRow : ''}
                                >
                                    {/* Month-Year / First Column */}
                                    <TableCell
                                        className={
                                            ele._id.year === 'Grand Total'
                                                ? classes.grandTotalFixedColumn
                                                : classes.fixedFirstColumn
                                        }
                                    >
                                        {ele._id.year === 'Grand Total'
                                            ? 'Grand Total'
                                            : `${months[ele.month]}-${ele.year % 100}`}
                                    </TableCell>

                                    {/* Design KickOff Internal */}
                                    <TableCell
                                        className={`${classes.tableCell} ${classes.clickableCell}`}
                                        onClick={() => dataBasedOnClick(ele, 'designKickOffInternal')}
                                    >
                                        {ele.designKickOffInternalCount || 0}
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>
                                        {ele.designKickOffInternal?.toFixed(2) || '0.00'}
                                    </TableCell>

                                    {/* Design KickOff Customer */}
                                    <TableCell
                                        className={`${classes.tableCell} ${classes.clickableCell}`}
                                        onClick={() => dataBasedOnClick(ele, 'designKickOffCustomer')}
                                    >
                                        {ele.designKickOffCustomerCount || 0}
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>
                                        {ele.designKickOffCustomer?.toFixed(2) || '0.00'}
                                    </TableCell>

                                    {/* Design */}
                                    <TableCell
                                        className={`${classes.tableCell} ${classes.clickableCell}`}
                                        onClick={() => dataBasedOnClick(ele, 'design')}
                                    >
                                        {ele.designCount || 0}
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>
                                        {ele.design?.toFixed(2) || '0.00'}
                                    </TableCell>

                                    {/* Design-Hold */}
                                    <TableCell
                                        className={`${classes.tableCell} ${classes.clickableCell}`}
                                        onClick={() => dataBasedOnClick(ele, 'design-Hold')}
                                    >
                                        {ele.designHoldcount || 0}
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>
                                        {ele.designHoldGrand?.toFixed(2) || '0.00'}
                                    </TableCell>

                                    {/* Completed */}
                                    <TableCell
                                        className={`${classes.tableCell} ${classes.clickableCell}`}
                                        onClick={() => dataBasedOnClick(ele, 'completed')}
                                    >
                                        {ele.completedCount || 0}
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>
                                        {ele.completed?.toFixed(2) || '0.00'}
                                    </TableCell>

                                    {/* Lost */}
                                    <TableCell
                                        className={`${classes.tableCell} ${classes.clickableCell}`}
                                        onClick={() => dataBasedOnClick(ele, 'lost')}
                                    >
                                        {ele.lostcount || 0}
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>
                                        {ele.lost?.toFixed(2) || '0.00'}
                                    </TableCell>

                                    {/* NPS-Design */}
                                    <TableCell
                                        className={`${classes.tableCell} ${classes.clickableCell}`}
                                        onClick={() => dataBasedOnClick(ele, 'npsDesign')}
                                    >
                                        {ele.npsDesignAverage ?? 'N/A'}
                                    </TableCell>

                                    {/* NPS-Post-Design */}
                                    <TableCell
                                        className={`${classes.tableCell} ${classes.clickableCell}`}
                                        onClick={() => dataBasedOnClick(ele, 'npsPostDesign')}
                                    >
                                        {ele.npsPostDesignAverage ?? 'N/A'}
                                    </TableCell>

                                    {/* Avg Ageing */}
                                    <TableCell
                                        className={`${classes.tableCell} ${classes.clickableCell}`}
                                        onClick={() => avgAgeingDataBasedOnClick(ele, 'avgAgeing')}
                                    >
                                        {(ele?.avgAgeingDays ?? 0).toFixed(0)}
                                    </TableCell>

                                    {/* Total */}
                                    <TableCell
                                        className={`${classes.tableCell} ${classes.totalClickableCell}`}
                                        onClick={() => dataBasedOnClick(ele, 'total')}
                                    >
                                        {(
                                            (ele.designKickOffInternalData?.length || 0) +
                                            (ele.designKickOffCustomerData?.length || 0) +
                                            (ele.designData?.length || 0) +
                                            (ele.designHoldData?.length || 0) +
                                            (ele.completedData?.length || 0) +
                                            (ele.lostData?.length || 0)
                                        )}
                                    </TableCell>
                                    <TableCell
                                        className={`${classes.tableCell} ${classes.totalClickableCell}`}
                                        onClick={() => dataBasedOnClick(ele, 'total')}
                                    >
                                        {(
                                            (ele.designKickOffInternal || 0) +
                                            (ele.designKickOffCustomer || 0) +
                                            (ele.design || 0) +
                                            (ele.designHoldGrand || 0) +
                                            (ele.completed || 0) +
                                            (ele.lost || 0)
                                        ).toFixed(2)}
                                    </TableCell>

                                    {/* Performance */}
                                    <TableCell
                                        className={`${classes.tableCell} ${getPerformanceClass(
                                            allPerformanceData[index]?.performancePercentage || 0
                                        )}`}
                                    >
                                        {allPerformanceData[index]?.performancePercentage || 0}%
                                    </TableCell>

                                    {/* Reward Points */}
                                    <TableCell className={classes.tableCell}>
                                        {ele.rewardsPoints || 0}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

            {/* Detailed Modal */}
            <Modal
                title={`Detailed View - ${selectedStage} (${selectedMonthData._id?.year === 'Grand Total' ? 'Grand Total' : `${months[selectedMonthData.month]}-${selectedMonthData.year % 100}`})`}
                centered
                open={showDetailedModal}
                onCancel={() => setShowDetailedModal(false)}
                width={1500}
                footer={null}
            >
                <div style={{ marginBottom: '10px', display: 'flex', gap: '10px' }}>
                    <Button
                        variant="contained"
                        onClick={downloadCSV}
                        className={classes.csvButton}
                        style={{ marginRight: '10px' }}
                    >
                        Download CSV
                    </Button>
                    <Button
                        variant="contained"
                        onClick={tableCsvDownloadHandler}
                        className={classes.csvButton}
                    >
                        Export Table to CSV
                    </Button>
                    <CSVLink
                        id="csv-download-link"
                        data={csvData}
                        headers={headers}
                        filename={`${selectedStage}_${selectedMonthData._id?.year === 'Grand Total' ? 'Grand_Total' : `${months[selectedMonthData.month]}_${selectedMonthData.year}`}.csv`}
                        style={{ display: 'none' }}
                    />
                    <CSVLink
                        headers={tableHeaders}
                        filename={`table_${selectedStage}_${selectedMonthData._id?.year === 'Grand Total' ? 'Grand_Total' : `${months[selectedMonthData.month]}_${selectedMonthData.year}`}.csv`}
                        data={tableCsvData}
                        ref={tableCsvButtonRef}
                        style={{ display: 'none' }}
                    />
                </div>

                <TableContainer component={Paper} style={{ maxHeight: '800px', overflow: 'auto' }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.modalTableHeader}>Sl. No.</TableCell>
                                <TableCell className={classes.modalTableHeader}>Project No.</TableCell>
                                <TableCell className={classes.modalTableHeader}>Lead No.</TableCell>
                                <TableCell className={classes.modalTableHeader}>Client Name</TableCell>
                                <TableCell className={classes.modalTableHeader}>Design Stage</TableCell>
                                <TableCell className={classes.modalTableHeader}>Current Stage</TableCell>
                                <TableCell className={classes.modalTableHeader}>Value (INR)</TableCell>
                                <TableCell className={classes.modalTableHeader}>Exp. Ctr. Name</TableCell>
                                <TableCell className={classes.modalTableHeader}>Sales Won Date</TableCell>
                                <TableCell className={classes.modalTableHeader}>Kick Off Meeting Date</TableCell>
                                <TableCell className={classes.modalTableHeader}>Design Sign-Off Date</TableCell>
                                <TableCell className={classes.modalTableHeader}>Ageing of Projects from KOM (Days)</TableCell>
                                <TableCell className={classes.modalTableHeader}>Material Delivery Date</TableCell>
                                <TableCell className={classes.modalTableHeader}>Actual Completion Date</TableCell>
                                <TableCell className={classes.modalTableHeader}>Nps Design</TableCell>
                                <TableCell className={classes.modalTableHeader}>Nps Post Design</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {selectedData?.map((data, index) => (
                                <TableRow key={index}>
                                    <TableCell className={classes.modalTableCell}>{index + 1}</TableCell>
                                    <TableCell className={classes.modalTableCell}>
                                        {data?.projectNo ? (
                                            <Link
                                                to={`/project-logs/${data?.leadId}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={classes.linkStyle}
                                            >
                                                {data?.projectNo}
                                            </Link>
                                        ) : 'NA'}
                                    </TableCell>
                                    <TableCell className={classes.modalTableCell}>
                                        {data?.leadNo ? (
                                            <Link
                                                to={`/project-logs/${data?.leadId}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={classes.linkStyle}
                                            >
                                                {data?.leadNo}
                                            </Link>
                                        ) : 'NA'}
                                    </TableCell>
                                    <TableCell className={classes.modalTableCell}>
                                        {data?.customerName || 'NA'}
                                    </TableCell>
                                    <TableCell className={classes.modalTableCell}>
                                        {data?.designStatus
                                            ? data?.designStatus
                                            : "-"}
                                    </TableCell>
                                    <TableCell className={classes.modalTableCell}>
                                        {data?.currentStage
                                            ? data?.currentStage
                                            : "-"}
                                    </TableCell>
                                    <TableCell className={classes.modalTableCell}>
                                        {selectedStage === "completed"
                                            ? ((data?.staticDesignWonAmount / 1.18) / 100000)?.toLocaleString("en-IN", {
                                                maximumFractionDigits: 2,
                                                style: "currency",
                                                currency: "INR",
                                            })
                                            : data?.staticSalesWonBudget?.toLocaleString("en-IN", {
                                                maximumFractionDigits: 2,
                                                style: "currency",
                                                currency: "INR",
                                            })}
                                    </TableCell>

                                    <TableCell className={classes.modalTableCell}>
                                        {data?.experienceCenterName
                                            ? data?.experienceCenterName
                                            : "-"}
                                    </TableCell>
                                    <TableCell className={classes.modalTableCell}>
                                        {data?.salesWonDate
                                            ? moment(data?.salesWonDate).format("DD-MM-YYYY")
                                            : "-"}
                                    </TableCell>
                                    <TableCell className={classes.modalTableCell}>
                                        {data?.dateOfKickOffMeeting
                                            ? moment(data?.dateOfKickOffMeeting).format("DD-MM-YYYY")
                                            : "-"}
                                    </TableCell>
                                    <TableCell className={classes.modalTableCell}>
                                        {data?.designSignOffDateActual
                                            ? moment(data?.designSignOffDateActual).format("DD-MM-YYYY")
                                            : "-"}
                                    </TableCell>
                                    <TableCell className={classes.modalTableCell}>
                                        {data?.dateOfKickOffMeeting
                                            ? (() => {
                                                if (!data.designSignOffDate) return "-";
                                                const diffDays = Math.floor(
                                                    (new Date(data.designSignOffDate) - new Date(data.dateOfKickOffMeeting)) /
                                                    (1000 * 60 * 60 * 24)
                                                );
                                                return isNaN(diffDays) ? "-" : diffDays;
                                            })()
                                            : "-"
                                        }
                                    </TableCell>
                                    <TableCell className={classes.modalTableCell}>
                                        {data?.materialDispatchedDate
                                            ? moment(data?.materialDispatchedDate).format("DD-MM-YYYY")
                                            : "-"}
                                    </TableCell>
                                    <TableCell className={classes.modalTableCell}>
                                        {data?.executionCompletionDate
                                            ? moment(data?.executionCompletionDate).format("DD-MM-YYYY")
                                            : "-"}
                                    </TableCell>
                                <TableCell className={classes.modalTableCell}>
                                        {data?.npsDesign
                                            ? data?.npsDesign
                                            : "-"}
                                    </TableCell>
                                    <TableCell className={classes.modalTableCell}>
                                        {data?.npsPostDesign
                                            ? data?.npsPostDesign
                                            : "-"}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Modal>

            {/* Latest Notes Dialog */}
            <Dialog
                open={showLatestNotes}
                onClose={() => setShowLatestNotes(false)}
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth='sm'
            >
                <DialogTitle id="form-dialog-title">
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span>Latest Notes</span>
                        <span style={{ fontSize: "0.8rem", color: "#666" }}>
                            {latestNotesDate ? moment(latestNotesDate).format('lll') : ""}
                        </span>
                    </div>
                </DialogTitle>
                <Divider />
                <DialogContent style={{ marginBottom: "18px" }}>
                    {latestNotesMsg || "No Notes"}
                </DialogContent>
            </Dialog>

            {/* Latest Deal Activity Dialog */}
            <Dialog
                open={showLatestDeal}
                onClose={() => setShowLatestDeal(false)}
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth='sm'
            >
                <DialogTitle id="form-dialog-title">
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span>Latest Deal Activity</span>
                        <span style={{ fontSize: "0.8rem", color: "#666" }}>
                            {latestDealDate ? moment(latestDealDate).format('lll') : ""}
                        </span>
                    </div>
                </DialogTitle>
                <Divider />
                <DialogContent style={{ marginBottom: "18px" }}>
                    {latestDealMsg || "No Activity"}
                </DialogContent>
            </Dialog>

            {/* Lost Details Dialog */}
            <Dialog
                open={showLostInfo}
                onClose={() => setShowLostInfo(false)}
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth='sm'
            >
                <DialogTitle id="form-dialog-title">
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span>Lost Activity</span>
                        <span style={{ fontSize: "0.8rem", color: "#666" }}>
                            {lostDealActivityDate ? moment(lostDealActivityDate).format('lll') : ""}
                        </span>
                    </div>
                </DialogTitle>
                <Divider />
                <DialogContent style={{ marginBottom: "18px" }}>
                    {lostDealActivity || "NA"}
                </DialogContent>
            </Dialog>

            {/* NPS Form Dialog */}
            <Dialog
                open={showNpsFormModal}
                onClose={() => setShowNpsFormModal(false)}
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth='md'
            >
                <DialogTitle id="form-dialog-title">
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span>Design Overall NPS Form/Feedback</span>
                        <span style={{ fontSize: "0.8rem", color: "#666" }}>
                            {npsCreatedDate ? moment(npsCreatedDate).format('lll') : ""}
                        </span>
                    </div>
                </DialogTitle>
                <Divider />
                <DialogContent style={{ marginBottom: "18px" }}>
                    <FormControl component="fieldset" style={{ marginBottom: 50 }}>
                        <FormLabel component="legend" style={{ color: "#000" }}>Satisfaction index - {avgScore}</FormLabel>
                        <FormLabel component="legend" style={{ color: "#000", marginTop: "30px" }}>
                            <span className={classes.satisfiedDetail}></span>
                            <span style={{ marginLeft: "10px" }}>Dissatisfied</span>
                            <span className={classes.DissatisfiedDetail} style={{ marginLeft: "20px" }}></span>
                            <span style={{ marginLeft: "10px" }}>Satisfied</span>
                        </FormLabel>
                    </FormControl>

                    <Table style={{ width: '100%', marginBottom: '20px' }}>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={10}></TableCell>
                                {[1, 2, 3, 4, 5].map((num) => (
                                    <TableCell
                                        key={num}
                                        style={{
                                            backgroundColor: getColor(num),
                                            color: '#fff',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {num}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Array.isArray(npsFormData) && npsFormData.length > 0 ? (
                                npsFormData.map((row, i) => (
                                    <TableRow key={i}>
                                        <TableCell colSpan={10}>{row?.description}</TableCell>
                                        {[1, 2, 3, 4, 5].map((num) => (
                                            <TableCell key={num} style={{ textAlign: 'center' }}>
                                                <Radio
                                                    value={String(num)}
                                                    checked={row?.actionSelected === String(num)}
                                                    style={{
                                                        backgroundColor: row?.actionSelected === String(num) ? '#fde6f0' : '',
                                                    }}
                                                />
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={15} style={{ textAlign: 'center' }}>
                                        No NPS Data
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                    <FormControl component="fieldset" style={{ marginBottom: 20, marginTop: 20 }}>
                        <FormLabel component="legend" style={{ color: "#000" }}>
                            Was the Design Manager involved in your interior design journey? *
                        </FormLabel>
                        <RadioGroup aria-label="designManagerInvolved" name="isDesignManagerInvolved">
                            <FormControlLabel
                                value="Yes"
                                control={<Radio color="primary" />}
                                label="Yes"
                                checked={isManagerInvolved === 'Yes'}
                            />
                            <FormControlLabel
                                value="No"
                                control={<Radio color="primary" />}
                                label="No"
                                checked={isManagerInvolved === 'No'}
                            />
                            <FormControlLabel
                                value="Not-applicable"
                                control={<Radio color="primary" />}
                                label="Not applicable"
                                checked={isManagerInvolved === 'Not-applicable'}
                            />
                        </RadioGroup>
                    </FormControl>

                    {isManagerInvolved === 'Yes' && (
                        <>
                            <FormControl component="fieldset" style={{ marginBottom: 50 }}>
                                <FormLabel component="legend" style={{ color: "#000" }}>Satisfaction index -</FormLabel>
                                <FormLabel component="legend" style={{ color: "#000", marginTop: "30px" }}>
                                    <span className={classes.satisfiedDetail}></span>
                                    <span style={{ marginLeft: "10px" }}>Dissatisfied</span>
                                    <span className={classes.DissatisfiedDetail} style={{ marginLeft: "20px" }}></span>
                                    <span style={{ marginLeft: "10px" }}>Satisfied</span>
                                </FormLabel>
                            </FormControl>

                            <Table style={{ width: '100%', marginBottom: '20px' }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell colSpan={10}></TableCell>
                                        {[1, 2, 3, 4, 5].map((num) => (
                                            <TableCell
                                                key={num}
                                                style={{
                                                    backgroundColor: getColor(num),
                                                    color: '#fff',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                {num}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.isArray(managerSatisfactionForm) && managerSatisfactionForm.length > 0 ? (
                                        managerSatisfactionForm.map((row, i) => (
                                            <TableRow key={i}>
                                                <TableCell colSpan={10}>{row?.description}</TableCell>
                                                {[1, 2, 3, 4, 5].map((num) => (
                                                    <TableCell key={num} style={{ textAlign: 'center' }}>
                                                        <Radio
                                                            value={String(num)}
                                                            checked={row?.actionSelected === String(num)}
                                                            style={{
                                                                backgroundColor: row?.actionSelected === String(num) ? '#fde6f0' : '',
                                                            }}
                                                        />
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={15} style={{ textAlign: 'center' }}>
                                                No Manager NPS Data
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </>
                    )}
                    <Divider />
                    <div style={{ marginTop: '20px' }}>
                        <strong>Feedback: </strong> {npsFeedback || "NA"}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowNpsFormModal(false)} color="primary" variant="contained">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    );
};

export default DesignNewSummary;
